import { Trans, useTranslation } from "react-i18next";
import Modal from "~/common/components/Modal";
import { Button, Stack } from "~/common/mui";
import { CART_PAGE } from "~/utils/url/staticUrls";

interface Props {
  onClose: () => void;
}

export const SoldOutCampaignModal = ({ onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      onClose={onClose}
      footerChildren={
        <Stack gap={1} direction="row">
          <Button variant={"text"} onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button href={CART_PAGE}>{t("feature.salesCampaign.cannotQuote.backToCart")}</Button>
        </Stack>
      }
    >
      <Stack gap={1}>
        <p className={"f-bold"}>
          <Trans i18nKey={"feature.salesCampaign.soldOut.partOne"} />
        </p>
        <p>
          <Trans i18nKey={"feature.salesCampaign.soldOut.partTwo"} />
        </p>
      </Stack>
    </Modal>
  );
};
